export function obj(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 4 },
        },
    };
}
